// Close Modal
window.closeModal = function (selector) {

  var modal = $(selector),
      modalOverlay = $('.cpatch-modal-overlay'),
      closeButton = modal.find('.cpatch-modal-close'),
      modalTitle = modal.find('.cpatch-modal-title'),
      modalContent = modal.find('.cpatch-modal-content'),
      body = $('body');

  // Scroll back to top
  modal.animate({
    scrollTop: 0
  }, 1, function() {
    // Remove escape key binding
    body.off('keydown');
    // Reset modal
    modal.removeClass('modal-open');
    modalOverlay.removeClass('modal-open');
    body.removeClass('modal-open');
    // Empty fields
    modalTitle.empty();
    modalContent.empty();
  });

  if ( $('.homepage-featured-slider').length ) {
    $('.homepage-featured-slider').slick('slickPlay');
  }
}; // end closeModal()

// Show modal
// Example usage: openModal('.cpatch-modal', [html_to_inject], [modal title text]);
window.openModal = function (selector, theModalContent, modalTitleText) {

  var modal = $(selector),
      modalOverlay = $('.cpatch-modal-overlay'),
      modalTitle = modal.find('.cpatch-modal-title'),
      modalContent = modal.find('.cpatch-modal-content'),
      body = $('body'),
      closeButton = modal.find('.cpatch-modal-close'),
      titleText = $.trim(modalTitleText);

  if ( selector == '#cpatch-video-modal' ) {
    modalOverlay.css('opacity', '1');
  } else {
    modalOverlay.css('opacity', '0.75');
  }

  modalTitle.text( titleText );
  modalContent.html( theModalContent );

  // Close Button closes modal
  closeButton.on('click', function(e) {
    e.preventDefault();
    closeModal(selector);
  });

  // Overlay click closes modal
  modalOverlay.on('click', function(e) {
    e.preventDefault();
    closeModal(selector);
  });

  // Escape key closes modal
  body.on('keydown', function(e) {
    e.preventDefault();
    // ESCAPE key pressed
    if ( $('.cpatch-modal.modal-open').length && e.which == 27 ) {
      closeModal(selector);
    }
  });

  // Show modal
  modal.addClass('modal-open');
  modalOverlay.addClass('modal-open');
  body.addClass('modal-open');
  modal.focus();

}; // end openModal()

// Trigger modal on .cpatch-image-slider image click
$('.cpatch-image-slider-container').on('click', '.cpatch-image-slide', function(e) {
  e.preventDefault();

  var theModalTitle = $(this).data('title'),
      theModalContent = $(this).html();

  openModal('#cpatch-image-modal', theModalContent, theModalTitle);
});